import SubscriberWidget from './SubscriberWidget'
import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'
import SocialMediaIntegrations from 'app/main/integrations/socialMediaIntegration/SocialMediaIntegrations'
import appConfigs from 'app/configs/appConfigs'

export const IntegrationConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.subscriberWidget(),
      component: SubscriberWidget,
      accesses: [AccessType.ADMINISTRATION],
    },
    {
      path: Routes.socialMediaIntegrations(),
      component: SocialMediaIntegrations,
      accesses: [AccessType.ADMINISTRATION],
    },
  ].filter(
    (route) =>
      appConfigs.isSocialPostingEnabled ||
      route.path !== Routes.socialMediaIntegrations(),
  ),
}
